import { Modal } from 'antd'
import { Button } from 'antd'
import openOnlinePayment from '@/modules/onlinePayment/features/jumpPage/openOnlinePayment'
import { goToMyPartnerShop } from '@/modules/distribute/utils/jumpMyPartnerShop'
import { goAfterSaleSettings } from '@/modules/order/helper'
import styles from './index.less'

export default props => {
    const { riskInfo, recordStatus, onCancel } = props

    const renderTitle = () => {
        if (riskInfo?.riskLevel === 'WARNING') {
            return '即将升级'
        }

        return '已升级'
    }

    const renderRestDay = () => {
        if (riskInfo?.riskLevel === 'WARNING') {
            return (
                <div style={{ display: 'flex', alignItems: 'center', marginTop: '1px', marginBottom: '3px' }}>
                    <img
                        src="https://assets.sursung.com/activity/20260317/4F61F928F1834738BFA2715FFA58817F1773712360018.png"
                        alt=""
                        width={32}
                        height={33}
                        style={{ marginRight: '8px' }}
                    />
                    <span
                        style={{
                            color: '#00B42A',
                            fontSize: '44px',
                            lineHeight: '18px',
                            fontWeight: 600,
                            marginTop: '-8px',
                        }}
                    >
                        {riskInfo.remainingWarningTime}
                    </span>
                    <span
                        style={{
                            color: '#1D2129',
                            fontSize: '16px',
                            fontWeight: 600,
                            lineHeight: '18px',
                            marginLeft: '4px',
                        }}
                    >
                        天后，将为您启用以下交易保障
                    </span>
                </div>
            )
        }

        return (
            <div style={{ display: 'flex', alignItems: 'center', marginTop: '2px', marginBottom: '11px' }}>
                <img
                    src="https://assets.sursung.com/activity/20260317/2E0BD2A6133247EBB962616CC7C051EC1773715095521.png"
                    alt=""
                    width={24}
                    height={24}
                />
                <span
                    style={{
                        color: '#00B42A',
                        fontSize: '16px',
                        fontWeight: 600,
                        lineHeight: '18px',
                        marginLeft: '8px',
                    }}
                >
                    交易保障已升级
                </span>
            </div>
        )
    }

    return (
        <Modal width={700} bodyStyle={{ padding: '8px' }} footer={false} {...props}>
            <div className={styles.topBg}>
                <img
                    src="https://assets.sursung.com/activity/20260316/3F74D5A8A8F2426DB7F3A682459737AE1773655045376.png"
                    alt=""
                    width={171}
                    height={133}
                    style={{
                        marginTop: '-38px',
                    }}
                />
                <div
                    style={{
                        color: '#1D2129',
                        fontSize: '24px',
                        fontWeight: 600,
                        lineHeight: '18px',
                        marginTop: '10px',
                    }}
                >
                    您的供分销交易保障{renderTitle()}
                </div>
                <div
                    style={{
                        color: '#1D2129',
                        fontSize: '14px',
                        fontWeight: 400,
                        lineHeight: '18px',
                        marginTop: '10px',
                    }}
                >
                    为了保障分销交易资金安全，促进生意长久合作，将为您
                    <span style={{ color: '#00B42A' }}>开启交易保障升级</span>
                </div>
            </div>
            <div className={styles.bottomBg} style={{ padding: '8px 20px', margin: '20px 16px 0' }}>
                {renderRestDay()}
                <div className={styles.cardWrapper}>
                    <div className={styles.switchCard} style={{ paddingTop: riskInfo?.onlinePay ? '50px' : '31px' }}>
                        <div
                            style={{
                                color: '#1D2129',
                                fontSize: '16px',
                                fontWeight: 600,
                                lineHeight: '18px',
                                textAlign: 'center',
                            }}
                        >
                            <span>分销商推单需</span>
                            <span style={{ color: '#00B42A' }}>在线支付</span>
                        </div>
                        <div
                            style={{
                                color: '#1D2129',
                                fontSize: '12px',
                                fontWeight: 400,
                                lineHeight: '18px',
                                marginTop: '4px',
                                textAlign: 'center',
                            }}
                        >
                            不可授信/线下转账，资金流转更安全
                        </div>

                        {riskInfo?.onlinePay ? (
                            <div
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    marginTop: '17px',
                                    textAlign: 'center',
                                    justifyContent: 'center',
                                }}
                            >
                                <img
                                    src="https://assets.sursung.com/activity/20260317/278EE287DAB546EEAABD818382D7650C1773713251252.png"
                                    alt=""
                                    width={14}
                                    height={14}
                                    style={{ marginRight: '8px' }}
                                />
                                <span style={{ color: '#00B42A', fontSize: '12px' }}>您已开启在线收付款账户</span>
                            </div>
                        ) : (
                            <div
                                style={{
                                    position: 'relative',
                                    width: '252px',
                                    marginLeft: '-8px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    padding: '8px 16px 10px',
                                    marginTop: '14px',
                                    background: '#FFE2E2',
                                }}
                            >
                                <img
                                    src="https://assets.sursung.com/activity/20260317/83D5CC776F3D4F4E993E7BD90A4325B41773719876747.png"
                                    alt=""
                                    width={7}
                                    style={{ position: 'absolute', left: 0, top: 0, transform: 'translateY(-100%)' }}
                                />
                                <div
                                    style={{
                                        width: '158px',
                                        color: '#F53F3F',
                                        fontSize: '12px',
                                        fontWeight: 400,
                                        lineHeight: '18px',
                                    }}
                                >
                                    您尚未开通在线收付款账户，将影响分销商推单
                                </div>
                                <a
                                    style={{
                                        marginLeft: '10px',
                                        fontSize: '12px',
                                        fontWeight: 600,
                                        lineHeight: '18px',
                                    }}
                                    onClick={() => {
                                        recordStatus()

                                        setTimeout(() => {
                                            openOnlinePayment({
                                                isWindowOpen: true,
                                            })
                                        }, 500)
                                    }}
                                >
                                    立即开通
                                </a>
                            </div>
                        )}
                    </div>

                    <div className={styles.descCard}>
                        <div style={{ color: '#4E5769', fontSize: '14px', fontWeight: 400, lineHeight: '18px' }}>
                            为您合作的所有分销商开启
                        </div>
                        <div style={{ display: 'flex', marginTop: '16px' }}>
                            <div style={{ width: '189px' }}>
                                <div
                                    style={{ color: '#1D2129', fontSize: '16px', fontWeight: 600, lineHeight: '18px' }}
                                >
                                    分销支付0费用
                                </div>
                                <div
                                    style={{
                                        color: '#1D2129',
                                        fontSize: '12px',
                                        fontWeight: 400,
                                        lineHeight: '18px',
                                        marginTop: '4px',
                                    }}
                                >
                                    新客愿合作 老客提营收
                                </div>
                                <a
                                    style={{ marginTop: '16px', display: 'inline-block' }}
                                    onClick={() => {
                                        recordStatus()

                                        setTimeout(() => {
                                            goToMyPartnerShop({
                                                openOnlinePaymentFree: 1,
                                                forceSupplierTerminal: true,
                                                _blank: true,
                                            })
                                        }, 500)
                                    }}
                                >
                                    了解详情
                                </a>
                            </div>
                            <div
                                style={{
                                    width: '1px',
                                    height: '52px',
                                    background: 'rgba(0, 0, 0, 0.10)',
                                    marginTop: '-1px',
                                }}
                            />
                            <div style={{ width: '169px' }}>
                                <div
                                    style={{ color: '#1D2129', fontSize: '16px', fontWeight: 600, lineHeight: '18px' }}
                                >
                                    无忧售后
                                </div>
                                <div
                                    style={{
                                        color: '#1D2129',
                                        fontSize: '12px',
                                        fontWeight: 400,
                                        lineHeight: '18px',
                                        marginTop: '4px',
                                    }}
                                >
                                    售后提效少纠纷
                                </div>
                                <a
                                    style={{ marginTop: '16px', display: 'inline-block' }}
                                    onClick={() => {
                                        recordStatus()

                                        setTimeout(() => {
                                            goAfterSaleSettings({
                                                query: { guideShow: 4 },
                                                forceSupplierTerminal: true,
                                                newBrowserTab: true,
                                            })
                                        }, 500)
                                    }}
                                >
                                    了解详情
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div style={{ textAlign: 'center', marginTop: '24px', marginBottom: '12px' }}>
                <Button onClick={() => onCancel()}>我知道了</Button>
            </div>
        </Modal>
    )
}
